import React from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';

export default function PolicyPage({ title, children }) {
    return (
        <div className="bg-la-canvas text-la-text min-h-screen">
            <Navbar />
            <main className="pt-28 pb-24">
                <div className="max-w-3xl mx-auto px-4 sm:px-6">
                    <div className="meta-eyebrow text-la-gold">Policy</div>
                    <h1 className="mt-3 font-display text-4xl sm:text-5xl text-la-text text-balance">{title}</h1>
                    <div className="mt-8 prose-invert max-w-none text-la-text2 leading-relaxed space-y-5 [&_h2]:font-display [&_h2]:text-la-text [&_h2]:text-xl [&_h2]:mt-8">
                        {children}
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export const PrivacyPage = () => (
    <PolicyPage title="Privacy Policy">
        <p>Legal Alliance Consultancy Ltd (“we”, “the firm”) handles client information with discretion appropriate to a private advisory practice. We collect only the information necessary to respond to a brief, deliver a consultation, manage payments and comply with applicable laws.</p>
        <h2>What we collect</h2>
        <p>Contact details you submit (name, email, phone), the content of your brief, any uploaded documents and transactional data associated with payments (reference, amount, status).</p>
        <h2>How we use it</h2>
        <p>To deliver consultations, manage matters, communicate with you, fulfil legal/regulatory obligations and improve our service. We do not sell client data.</p>
        <h2>Retention</h2>
        <p>We retain records for periods required by law or by the nature of the engagement, and securely dispose of data when no longer needed.</p>
        <h2>Your rights</h2>
        <p>You may request access, correction, deletion or export of your data by writing to contact@legalallianceconsultancy.com.</p>
        <h2>Security</h2>
        <p>We use TLS in transit, restricted access and reputable third-party processors (e.g., Stripe) under their own compliance regimes.</p>
    </PolicyPage>
);

export const TermsPage = () => (
    <PolicyPage title="Terms of Service">
        <p>By engaging Legal Alliance Consultancy Ltd you agree to the following terms. These terms govern access to our website and the consultations and advisory services we provide.</p>
        <h2>Scope of engagement</h2>
        <p>Each engagement is scoped in writing. Public information on this website is provided for general guidance and does not constitute legal advice or representation.</p>
        <h2>Fees</h2>
        <p>Fees are agreed on scope. Payments are processed securely via Stripe in GBP unless otherwise agreed. Disputes about specific payments should be raised in writing within 14 days.</p>
        <h2>Confidentiality</h2>
        <p>We treat all client information as confidential and require similar handling from our specialists and partners.</p>
        <h2>Limitations</h2>
        <p>Information provided in consultations is given in good faith based on the facts presented. We are not responsible for outcomes shaped by information withheld or by subsequent events outside our control.</p>
        <h2>Governing law</h2>
        <p>Unless otherwise agreed in writing, our engagements are governed by the laws of England and Wales.</p>
    </PolicyPage>
);

export const DisclaimerPage = () => (
    <PolicyPage title="Consultation Disclaimer">
        <p>Materials on this website and information shared during initial briefings are general guidance only. They do not constitute legal advice, regulated financial advice, or formal representation.</p>
        <p>A formal advisory relationship is only created once a scope of engagement has been agreed in writing and accepted by the firm. Consultations may include references to publicly available material and general principles; specific advice depends on a full review of your matter.</p>
        <p>If you require formal legal representation, please ask and we will refer you to a regulated practitioner from our specialist network.</p>
    </PolicyPage>
);
